import { Button } from "@/components/buttons/button"
import { SortOrderStateProps } from "@/components/comparison_group_list/types"
import { CaretDown, CaretUp, CaretUpDown } from "@phosphor-icons/react"

interface ButtonSortingProps {
  onClick: () => void
  columnName: string
  sortOrder: SortOrderStateProps
  className?: string
  text?: string
}

export function ButtonSorting({
  columnName,
  onClick,
  sortOrder,
  className,
  text,
}: ButtonSortingProps) {
  return (
    <Button
      className={`${className} flex items-center gap-0.5 focus:border-0 focus:shadow-none focus:outline-none`}
      color="tertiary"
      onClick={onClick}>
      {text ?? <p>{text}</p>}
      {sortOrder.column === columnName ?
        <span>
          {sortOrder.direction === "desc" ?
            <CaretDown aria-hidden="true" />
          : <CaretUp aria-hidden="true" />}
        </span>
      : <CaretUpDown aria-hidden="true" />}
    </Button>
  )
}
